<template>
  <div class="plan">
    <NavBar type="plan" />
    <div class="banner">
      <div class="title">行业化解决方案</div>
      <div class="subtitle">
        <div>为您量身定制整体解决方案，助力业绩增长</div>
        <div>支持本地化部署和系统打通，实现数据安全和业务闭环</div>
      </div>
      <div class="btn" @click="openAppoint">立即预约</div>
    </div>
    <div class="exhibition">
      <div class="exhibition_con">
        <div>新闻与活动</div>
        <div class="wow slideInUp">
          <div class="exhibition_item" @click="article('https://cloud.tencent.com/developer/article/1892234?from=article.detail.1902177')">
            <div class="exhibition_img">
              <img src="https://resource.51beauty.com.cn/f17ab896-e595-4a3e-bda8-7258a73e1e48?imageslim" alt="">
            </div>
            <div class="exhibition_text">
              <div class="title">腾讯SaaS加速器三期总决选</div>
              <div class="subtitle">云晰科技从1100家报名SaaS企业中顺利突围，获得最终角逐Top 40席位的入场券。</div>
            </div>
          </div>
          <div class="exhibition_item" @click="article('https://cloud.tencent.com/document/product/306/47166')">
            <div class="exhibition_img">
              <img src="https://resource.51beauty.com.cn/a5826992-7c89-4adf-bbca-c986ca84e718?imageslim" alt="">
            </div>
            <div class="exhibition_text">
              <div class="title">云晰科技已通过腾讯云千帆计划复选</div>
              <div class="subtitle">营销云产品已上架腾讯云市场，成为“千帆甄选”推荐产品。</div>
            </div>
          </div>
          <div class="exhibition_item" @click="article('https://baijiahao.baidu.com/s?id=1718001203675989497&wfr=spider&for=pc')">
            <div class="exhibition_img">
              <img src="https://resource.51beauty.com.cn/4bc47af4-78d0-4a64-95b3-be41e94b212e?imageslim" alt="">
            </div>
            <div class="exhibition_text">
              <div class="title">云晰科技和企业微信官方合作组织沙龙会</div>
              <div class="subtitle">云晰与企业微信深度合作共创，将企微作为腾讯新流量生态的结合点，帮助客户探索私域增长…</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- 专注消费医疗 -->
    <Bottom />
    <appointment
            :visibleDialog="appointmentVisible"
            @closeAppoint="closeAppoint"
    />
    <Contact/>
  </div>
</template>
<script>
  import NavBar from "@/components/navBarProduct.vue";
  import Bottom from "@/components/bottom.vue";
  import Appointment from "@/components/appointment.vue";
  import Contact from "@/components/contact.vue";
  import { WOW } from 'wowjs'

  export default {
    components: {
      NavBar,
      Bottom,
      Appointment,
      Contact
    },
    data() {
      return {
        painSpotList:[
          {
            img:'https://resource.51beauty.com.cn/3173fcd8-c51c-495d-b29d-5000770da8bd?imageslim',
            title: '获客成本高',
            subtitle: '电商已成为医美机构获客的主流平台，但因竞争激烈，造成获客成本高，机构被迫陷入价格战，亟需寻找新的流量池'
          },
          {
            img:'https://resource.51beauty.com.cn/79186bf7-bc72-4113-8ed5-b46361f029d5?imageslim',
            title: '客户画像不清晰',
            subtitle: '咨询师无法在个人微信进行标签化统一管理，营销活动无法精确匹配到有需求的客户'
          },
          {
            img:'https://resource.51beauty.com.cn/71b590a5-dc9c-4cc7-b0c4-f34cb48aa078?imageslim',
            title: '业绩提升难',
            subtitle: '机构难以了解咨询师与客户之间的沟通内容，服务质量无法得到保障，业绩提升难'
          },
          {
            img:'https://resource.51beauty.com.cn/b16c25c9-92b9-42d4-bf71-38f5669b34f7?imageslim',
            title: '客户留存差',
            subtitle: '咨询师离职时，可能私自带走客户或在职咨询师可能产生飞单、私单风险，造成一定的客户资源流失'
          },
        ],
        appointmentVisible:false
      };
    },
    mounted() {
      new WOW().init()
    },
    methods: {
      // 关闭预约弹层
      closeAppoint (e) {
        this.appointmentVisible = e
      },
      // 打开预约弹层
      openAppoint () {
        this.appointmentVisible = true
      },
    },
  };
</script>
<style scoped lang="less">
  .plan{
    /deep/ .navbar {
      background: #2C68FF !important;
    }
    .banner{
      background: url("https://resource.51beauty.com.cn/qianduan_forever/e6afd88badef4370a0d8744b31c591f4/industry-specific-solutions-banner.png") no-repeat;
      background-size: cover;
      width: 375px;
      height: 156px;
      padding: 60px 0 0 69px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      .title{
        font-weight: 500;
        font-size: 11px;
        color: #2C69FF;
      }
      .subtitle{
        font-weight: 400;
        font-size: 4px;
        color: #273755;
      }
      .btn{
        background: #2C68FF;
        font-weight: 500;
        font-size: 7px;
        color: #FFFFFF;
        margin-top: 11px;
        height: 18px;
        width: 47px;
        margin-top: 33px;
        border-radius: 1px;
        line-height: 18px;
        text-align: center;
        color: #fff;
        cursor: pointer;
      }
    }
    .exhibition{
      background: #FAFBFD;
      padding-bottom: 29px;
      .exhibition_con{

        >div:nth-child(1){
          font-size: 8px;
          font-weight: bold;
          text-align: center;
          padding: 29px 0 12px 0;
        }
        >div:nth-child(2){
          width: 235px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          .exhibition_item{
            width: 73px;
            height: 81px;
            background: #fff;
            cursor: pointer;
            transition: .3s;
            border-radius: 3px;
            .exhibition_img{
              height: 55px;
              background: #FFFFFF;
              margin: 0 auto;
              img{
                width: 59px;
                margin: 0 auto;
                margin-top: 4px;
                display: block;
              }
              box-shadow: 0px 2px 4px 0px rgba(55,99,170,0.06);
            }
            >.exhibition_text{
              background: #fff;
              width: 100%;
              height: 26px;
              margin-top: .3px;
              box-shadow: 0px 2px 4px 0px rgba(55,99,170,0.06);
              border-radius: 0px 0px 3px 3px;
              >div:nth-child(1){
                font-weight: bold;
                font-size: 3px;
                margin-left: 5px;
                padding-top: 5px;
              }
              >div:nth-child(2){
                padding: 0 5px;
                margin-top: 2px;
                color: #273755;
                font-size: 3px;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
              }
            }
          }
          .exhibition_item:hover{
            transform: scale(1.1);
          }
        }
      }
    }
  }
</style>